import React, { Component } from "react";

const TemplateWrapper = (WrapperComponent, props = {}) => {
  class Template extends Component {
    render() {
      return (
        <main className="">
          <WrapperComponent {...this.props} />
        </main>
      );
    }
  }

  return Template;
};

export default TemplateWrapper;
